import { Prisma } from "@prisma/client";
import { ExhibitorProfilesPackPrestationType } from "../prestations.types";
import { NullablePartial, Paginated, Sortable } from "../utils.types";

export const eventExhibitorsStructuresTypeValues =
  Prisma.validator<Prisma.StructureDefaultArgs>()({
    select: {
      id: true,
      picture: true,
      businessName: true,
      businessEmail: true,
      phoneNumber: true,
    },
  });

type EventExhibitorStructure = Prisma.StructureGetPayload<
  typeof eventExhibitorsStructuresTypeValues
>;

export const eventExhibitorsEventStructuresTypeValues =
  Prisma.validator<Prisma.EventStructureDefaultArgs>()({
    select: {
      exhibitorProfilesPack: true,
      promotionDateRanges: {
        select: {
          from: true,
          to: true,
        },
      },
    },
  });

type EventExhibitorEventStructure = Prisma.EventStructureGetPayload<
  typeof eventExhibitorsEventStructuresTypeValues
>;

export type EventExhibitor = EventExhibitorStructure &
  NullablePartial<EventExhibitorEventStructure>;

export type EventExhibitorsFilters = Partial<
  Sortable<
    Paginated<{
      searchText?: string;
      exhibitorProfilesPackPrestationType?: ExhibitorProfilesPackPrestationType;
    }>
  >
>;

export type EventExhibitorPack = {
  exhibitorProfilesPack: ExhibitorProfilesPackPrestationType | null;
};
